import styled from 'styled-components';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Locked24, MultipleUsers24 } from 'ui/icons';
import { ListedView } from 'modules/savedViewsIndex/types';
import { RadioList } from 'ui/radioList';
import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';
import { makeACopyRequest } from 'modules/savedViewsIndex/redux/actions';
import { BoldSpan } from '../../../Styled';

const Label = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDiv = styled.div`
  margin-bottom: ${spacing.base};
`;

const ShiftedSpan = styled.span`
  margin-left: ${spacing.quarter};
`;
type Props = {
  view: ListedView;
  copyCallback: () => void;
  onClose: () => void;
};

export const CopyModal = ({ view, copyCallback, onClose }: Props) => {
  const dispatch = useDispatch();
  const [access, setAccess] = useState('private');

  const accessOpts = [
    {
      id: 'private',
      value: 'private',
      name: () => (
        <Label>
          <Locked24 /> <ShiftedSpan>Only me</ShiftedSpan>
        </Label>
      ),
      description: 'Only you can see and edit this view',
    },
    {
      id: 'public',
      value: 'public',
      name: () => (
        <Label>
          <MultipleUsers24 /> <ShiftedSpan>Anyone in this project</ShiftedSpan>
        </Label>
      ),
      description: 'Anyone in this project can see and edit this view',
    },
  ];

  const handleClick = () => {
    dispatch(makeACopyRequest(view.id, access === 'private', copyCallback));
    onClose();
  };

  return (
    <Modal
      id="exportModal"
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>Copy saved view</ModalHeader>
      <ModalBody>
        <StyledDiv>
          This will create a copy of <BoldSpan>{view.name}</BoldSpan>
        </StyledDiv>
        <FormField labelText="Who can access">
          <RadioList
            name="Who can access"
            onSelect={(val) => setAccess(val.value)}
            options={accessOpts}
            value={access}
          />
        </FormField>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton onClick={handleClick} size={BUTTON_SIZES.LARGE}>
          Copy saved view
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
